import { render } from "./DropdownItem.vue?vue&type=template&id=64a37e0c"
import script from "./DropdownItem.vue?vue&type=script&lang=js"
export * from "./DropdownItem.vue?vue&type=script&lang=js"
script.render = render

export default script